<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Integrations</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-row>
        <b-col md="3">
          <b-card no-body id="fub">
            <b-card-body>
              <div class="text-center">
                <img src="/img/integrations/fub-logo.png" class="w-100 mb-4 integration-logo" />
              </div>
              <h3 class="title">Follow Up Boss</h3>
              <p>Integrate Follow Up Boss with ClarityNOW...</p>
              <b-button block variant="outline-danger" to="/integrations/follow-up-boss" v-if="subscribed">Launch</b-button>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col md="3">
          <b-card no-body id="quickbooks">
            <b-card-body>
              <div class="text-center">
                <img src="/img/integrations/quickbooks-logo.png" class="w-100 mb-4 integration-logo" />
              </div>
              <h3 class="title">QuickBooks</h3>
              <p>Integrate QuickBooks with ClarityNOW...</p>
              <b-button block variant="outline-danger" to="/integrations/quickbooks" v-if="subscribed">Launch</b-button>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <upgrade-modal :graphic="'dashboard.png'" :subscribed="subscribed"></upgrade-modal>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import UpgradeModal from '@/views/Components/Modals/UpgradeModal';

export default {
  components: {
    RouteBreadCrumb,
    UpgradeModal
  },
  computed: {
    ...mapGetters({
      subBasic: 'profile/subBasic',
      subStandard: 'profile/subStandard',
      subPremium: 'profile/subPremium'
    }),
    subscribed() {
      return this.subBasic || this.subStandard || this.subPremium;
    },
  },
  mounted() {
    document.title = "Integrations | ClarityNOW";
  }
}
</script>